import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { RoomNoService } from '../service/room-no.service';
import { LanguageService } from '../service/language.service';
import { SideBar } from '../shared/component/sidebar/siderbar';
import { Subscription } from 'rxjs';

import {
  getNowDateObject,
  getStreamNowDate
} from '../shared/tools/DateNowTime';
import { nowDate } from '../index/nowDate';
import { Router } from '@angular/router';
import { KeyCode } from '../shared/const/KeyCode';

@Component({
  selector: 'app-yakkan',
  templateUrl: './yakkan.component.html',
  styleUrls: ['./yakkan.component.scss']
})
export class YakkanComponent implements OnInit, OnDestroy {
  now_date = getStreamNowDate();
  now_date_obj: nowDate = getNowDateObject(
    new Date(),
    this.languageService.language
  );
  sub: Subscription[] = [];
  imgurl: string;
  appname: string;
  focusIndex = 0;
  hotelIndex = 0;
  lang: 'jpn' | 'eng';

  room_no = '';
  yakkan = require('./yakkan.json');
  kiyaku = require('./kiyaku.json');
  side_index = 0; // 本文、規約で何P目を表示するかのindex
  side_bar_index = 0; // サイドバーのフォーカスindex
  is_yakkan = true; // 約款か規約どちらを表示するか
  sidebar: SideBar<YakkanSideBarTiTleJpn, YakkanSideBarTitleEng>[] = [
    {
      title: '宿泊約款',
      title_jpn: '宿泊約款',
      title_eng: 'Regulation',
      checked: true,
      key_code: '1',
      focused: false
    },
    {
      title: '利用規約',
      title_jpn: '利用規約',
      title_eng: 'Terms of service',
      checked: false,
      key_code: '2',
      focused: false
    },
    {
      title: 'メニューへ戻る',
      title_jpn: 'メニューへ戻る',
      title_eng: 'Back to menu',
      checked: false,
      key_code: '92',
      focused: false
    }
  ];
  yakkan_name: string;
  constructor(
    private router: Router,
    private roomNoService: RoomNoService,
    private languageService: LanguageService,

    private el: ElementRef
  ) {}
  element: HTMLElement;

  ngAfterViewInit() {
    (<any>document.querySelector('.tab_menu_li')).focus();
  }

  ngOnInit() {
    document.onkeydown = this.pushButton.bind(this);

    // Languageをサービスしちゃう
    this.lang = this.languageService.language;
    if (this.languageService.language === 'eng') {
      this.yakkan_name = 'Regulation';

      this.sidebar = this.sidebar.map(d => {
        return {
          title: d.title_eng,
          title_jpn: d.title_jpn,
          title_eng: d.title_eng,
          key_code: d.key_code,
          checked: d.checked,
          focused: d.focused
        };
      });
    } else {
      this.yakkan_name = '宿泊約款/利用規約';
    }

    // 約款と規約の日本語英語切り替え
    this.yakkan = this.yakkan.map((d: { path: string }) => {
      return {
        path: d.path.replace('jpn', this.languageService.language)
      };
    });

    this.kiyaku = this.kiyaku.map((d: { path: string }) => {
      return {
        path: d.path.replace('jpn', this.languageService.language)
      };
    });
  }
  ngOnDestroy() {
    document.onkeydown = null;
  }

  pushButton(ev: KeyboardEvent) {
    // TODO チャンネルボタン押された時の処理
    this.side_bar_index = this.hotelIndex;
    ev.stopPropagation();
    if (ev.keyCode === KeyCode.VK_RIGHT) {
      // 横方向のインデックスインクリメント
      this.scrollDown();
    } else if (ev.keyCode === KeyCode.VK_LEFT) {
      // 横方向のインデックスデクリメント
      this.scrollUp();
    } else if (
      ev.keyCode === KeyCode.VK_DOWN &&
      this.side_bar_index !== this.sidebar.length - 1
    ) {
      // 縦方向のインデックスインクリメント
      this.side_bar_index = this.side_bar_index + 1;
    } else if (ev.keyCode === KeyCode.VK_UP && this.side_bar_index !== 0) {
      // 縦方向のインデックスデクリメント
      this.side_bar_index = this.side_bar_index - 1;
    } else if (ev.keyCode === KeyCode.VK_ENTER) {
      this.clickSideBar();
    }
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.side_bar_index].checked = true;
  }

  clickSideBar() {
    if (
      ['宿泊約款', 'Regulation'].includes(
        this.sidebar[this.side_bar_index].title
      )
    ) {
      this.is_yakkan = true;
    } else if (
      ['利用規約', 'Terms of service'].includes(
        this.sidebar[this.side_bar_index].title
      )
    ) {
      this.is_yakkan = false;
    } else if (
      ['メニューへ戻る', 'Back to menu'].includes(
        this.sidebar[this.side_bar_index].title
      )
    ) {
      this.roomNoService.source = 'yakkan';
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }

  setFocusIndex(index: number) {
    if (index === 2) {
      return false;
    }
    this.focusIndex = index;
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.focusIndex].checked = true;
    this.hotelIndex = index;
  }

  setClickIndex(index: number) {
    if (index === 2) {
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }

  scrollDown() {
    (document.querySelector('.keiyaku') as HTMLDivElement).scrollBy(0, 700);
  }

  scrollUp() {
    (document.querySelector('.keiyaku') as HTMLDivElement).scrollBy(0, -700);
  }
}

declare function require(x: string): any;
type YakkanSideBarTiTleJpn = '宿泊約款' | '利用規約';
type YakkanSideBarTitleEng = 'Regulation' | 'Terms of service';
